import { Controller } from "@hotwired/stimulus"

export default class ChatMessagesController extends Controller {
  static targets = ["messages", "input"]

  connect() {
    this.pinToBottom()
    this.observeMessages()
    this.focus()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  pinToBottom() {
    this.pinnedToBottom = true
    this.scrollToBottom()
  }

  observeMessages() {
    this.observer = new MutationObserver(() => {
      if (this.pinnedToBottom) this.scrollToBottom()
    })
    this.observer.observe(this.messagesTarget, { childList: true })
  }

  trackScrollPosition() {
    const { scrollTop, scrollHeight, clientHeight } = this.messagesTarget
    this.pinnedToBottom = scrollHeight - scrollTop - clientHeight < 80
  }

  scrollToBottom() {
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
  }

  submitOnEnter(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.inputTarget.closest("form").requestSubmit()
    }
  }

  resize() {
    this.inputTarget.style.height = "auto"
    this.inputTarget.style.height = `${Math.min(this.inputTarget.scrollHeight, 160)}px`
  }

  resetInput() {
    this.inputTarget.closest("form").reset()
    this.inputTarget.style.height = "auto"
    this.pinToBottom()
  }

  focus() {
    this.inputTarget.focus()
  }
}
